// extracted by mini-css-extract-plugin
export default {"formContent":"WarehouseRelationshipForm_formContent__tU5pf"};